import React, { useState } from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';
import contactBanner from '../../assets/another page banner/contact us.jpg';
import locationIcon from '../../assets/location.png';
import './ContactUs.css';


const WA_ICON = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const waNumber = '919444058659';

const UNIT_I_SPECS = [
  '3D Machining VMC Job Works Undertaken',
  'VMC Table Size: 2000 × 1000 × 1000',
  'With 4th Axis Capability',
  'CNC & VMC Machines',
  'TIG, CO₂, Arc Welding Job Works Undertaken',
];

const UNIT_II_SPECS = [
  'CNC VTL (Berthiez) — Max Swing Dia: 8200 mm',
  'Table Dia: 4000 mm | Max Cutting Height: 3500 mm',
  'Load Capacity: 100 Ton',
  'CNC Gantry Floor Boring Machine',
  'Spindle Dia: 225 mm | X Axis: 14000 mm',
  'Y Axis: 4000 mm | Z Axis: 3500 mm',
  'Distance Between Columns: 5500 mm',
];

const BOTTOM_SPECS = [
  'Berthiez CNC VTL Diameter 8200 mm',
  'CNC Gantry Floor Boring M/C 16000 × 4000 × 3500',
  'VMC Table 2000 × 1000 With 4th Axis',
];

// ── 3 Partners data ──
const PARTNERS = [
  {
    name: 'V. Natarajan',
    role:  'Partner',
    phones: ['+91 94449 55108', '+91 80725 18489'],
    emails: ['natarajan.vm1971@gmail.com', 'natarajan_vm@rediffmail.com'],
    color: '#1E3A8A',
    initial: 'N',
  },
  {
    name: 'Baraneetharan',
    role: 'Partner',
    phones: ['+91 94440 58659', '+91 80725 15869'],
    emails: ['btharan76@gmail.com', 'baranee_i@rediffmail.com'],
    color: '#C8102E',
    initial: 'B',
  },
  {
    name: 'C.A Baskar',
    role: 'Partner',
    phones: ['+91 94440 00659'],
    emails: ['sales.milltechcnc@gmail.com', 'info.milltechcnc@gmail.com'],
    color: '#059669',
    initial: 'B',
  },
];

// ── Unit addresses with correct Google Maps direct links ──
const UNITS = [
  {
    label: 'Unit I',
    address: 'No. 101/1, 14th Main Road, SIDCO Industrial Estate, Thirumudivakkam, Chennai – 600132',
    mapLink: 'https://www.google.com/maps/place/MILLTECH+CNC/@12.9770853,80.083075,17z/data=!3m1!4b1!4m6!3m5!1s0x3a5267473fc40905:0x11649cef00b96a27!8m2!3d12.9770853!4d80.083075!16s%2Fg%2F11fmy0mnr1?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D',
    badge: '--ub1',
    embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.89!2d80.0715!3d12.9874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267473fc40905%3A0x11649cef00b96a27!2sMILLTECH+CNC!5e0!3m2!1sen!2sin!4v1686000000000!5m2!1sen!2sin',
  },
  {
    label: 'Unit II',
    address: 'Plot No. 28, Arul Murugan Nagar, MKB Industrial Estate, Thirumudivakkam, Chennai – 600132',
    mapLink: 'https://www.google.com/maps/place/MILLTECH+CNC+---UNIT+2/@12.9645983,80.0830425,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52f5400a72f09d:0x645c791a6668f1a4!8m2!3d12.9645931!4d80.0856174!16s%2Fg%2F11flhf5kmd?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D',
    badge: '--ub2',
    embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.9!2d80.0680!3d12.9855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52f5400a72f09d%3A0x645c791a6668f1a4!2sMILLTECH+CNC+---UNIT+2!5e0!3m2!1sen!2sin!4v1686000000001!5m2!1sen!2sin',
  },
];

const ContactUs = () => {
  const formRef = useScrollReveal();
  const infoRef = useScrollReveal();
  const mapRef  = useScrollReveal();

  const [form,   setForm]   = useState({ name: '', company: '', phone: '', email: '', service: '', message: '' });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');
  const [shake,  setShake]  = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'Name is required';
    if (!form.phone.trim())   e.phone   = 'Phone is required';
    else if (!/^\+?[\d\s\-(]{7,}$/.test(form.phone)) e.phone = 'Enter a valid phone number';
    if (!form.email.trim())   e.email   = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Enter a valid email';
    if (!form.message.trim()) e.message = 'Please describe your requirement';
    else if (form.message.trim().length < 10) e.message = 'At least 10 characters required';
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
    if (errors[name]) setErrors(p => ({ ...p, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      setShake(true);
      setTimeout(() => setShake(false), 600);
      return;
    }
    setStatus('loading');
    const subject = encodeURIComponent(`CNC Enquiry from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nCompany: ${form.company || 'N/A'}\nPhone: ${form.phone}\nEmail: ${form.email}\nService: ${form.service || 'General'}\n\nRequirement:\n${form.message}`
    );
    window.open(`mailto:btharan76@gmail.com?subject=${subject}&body=${body}`, '_blank');
    setTimeout(() => {
      setStatus('success');
      setForm({ name: '', company: '', phone: '', email: '', service: '', message: '' });
    }, 800);
  };

  const waText = encodeURIComponent(
    `Hello MILLTECH CNC,\n\nI am interested in your CNC machining services.\n\nName: ${form.name || '[Your Name]'}\nPhone: ${form.phone || '[Your Phone]'}\nRequirement: ${form.message || '[Describe requirement]'}`
  );
  const waLink = `https://wa.me/${waNumber}?text=${waText}`;

  return (
    <main className="contact-page">

      {/* ── HERO ── */}
      <section className="contact-hero">
        <div className="contact-hero__bg">
          <img src={contactBanner} alt="Contact MILLTECH CNC" className="contact-hero__bg-img" />
          <div className="contact-hero__bg-overlay" />
        </div>
        <div className="container contact-hero__content">
          <h1 className="contact-hero__title">Let's Build<br/><span>Together</span></h1>
          <p className="contact-hero__sub">
            Ready to discuss your machining requirements? Our engineering team responds within 24 hours.
          </p>
          <div className="contact-hero__pills">
            <a href="tel:+919444058659" className="contact-hero__pill">
              <span className="contact-hero__pill-icon">📞</span>
              +91 94440 58659
            </a>
            <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noopener noreferrer" className="contact-hero__pill contact-hero__pill--wa">
              {WA_ICON}
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* ── MAIN CONTENT ── */}
      <section className="contact-section section">
        <div className="container contact-grid">

          {/* FORM */}
          <div className="contact-form-col" ref={formRef}>
            <div className="reveal from-left">
             
              <h2 className="contact-form-col__heading">Tell Us Your<br/><span>Requirements</span></h2>
              <div className="red-line"/>
            </div>

            {status === 'success' ? (
              <div className="contact-success reveal">
                <div className="contact-success__check">✓</div>
                <h3>Message Received!</h3>
                <p>Your email client should have opened. We'll get back to you within 24 hours. Thank you for reaching out to MILLTECH CNC.</p>
                <div className="contact-success__actions">
                  <button className="btn btn-outline" onClick={() => setStatus('idle')}>Send Another</button>
                  <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noopener noreferrer" className="btn btn-wa">
                    {WA_ICON} Chat on WhatsApp
                  </a>
                </div>
              </div>
            ) : (
              <form
                className={`contact-form reveal delay-2 ${shake ? 'contact-form--shake' : ''}`}
                onSubmit={handleSubmit}
                noValidate
              >
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label" htmlFor="name">Full Name *</label>
                    <input
                      id="name" name="name" type="text"
                      className={`form-input ${errors.name ? 'form-input--error' : ''}`}
                      placeholder="Your full name"
                      value={form.name} onChange={handleChange}
                    />
                    {errors.name && <span className="form-error">{errors.name}</span>}
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="company">Company / Organisation</label>
                    <input
                      id="company" name="company" type="text"
                      className="form-input"
                      placeholder="Optional"
                      value={form.company} onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label" htmlFor="phone">Phone Number *</label>
                    <input
                      id="phone" name="phone" type="tel"
                      className={`form-input ${errors.phone ? 'form-input--error' : ''}`}
                      placeholder="+91 9XXXXXXXXX"
                      value={form.phone} onChange={handleChange}
                    />
                    {errors.phone && <span className="form-error">{errors.phone}</span>}
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="email">Email Address *</label>
                    <input
                      id="email" name="email" type="email"
                      className={`form-input ${errors.email ? 'form-input--error' : ''}`}
                      placeholder="your@email.com"
                      value={form.email} onChange={handleChange}
                    />
                    {errors.email && <span className="form-error">{errors.email}</span>}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="service">Service Required</label>
                  <select
                    id="service" name="service"
                    className="form-input form-select"
                    value={form.service} onChange={handleChange}
                  >
                    <option value="">Select a service...</option>
                    <option value="aerospace">Aerospace CNC Components</option>
                    <option value="vtl">VTL / CNC Turning (Large Diameter)</option>
                    <option value="fabrication">Heavy Fabrication</option>
                    <option value="windmill">Windmill Components</option>
                    <option value="defence">Defence / Missile Components</option>
                    <option value="other">Other / General Enquiry</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="message">Requirement Details *</label>
                  <textarea
                    id="message" name="message" rows={5}
                    className={`form-input form-textarea ${errors.message ? 'form-input--error' : ''}`}
                    placeholder="Describe your machining requirement — component name, dimensions, material, tolerance, quantity..."
                    value={form.message} onChange={handleChange}
                  />
                  {errors.message && <span className="form-error">{errors.message}</span>}
                </div>

                <div className="contact-form__actions">
                  <button type="submit" className="btn btn-primary contact-submit" disabled={status === 'loading'}>
                    {status === 'loading' ? (
                      <><span className="contact-spinner"/>Sending...</>
                    ) : 'Send Message →'}
                  </button>
                  <a href={waLink} target="_blank" rel="noopener noreferrer" className="btn btn-wa">
                    {WA_ICON} WhatsApp
                  </a>
                </div>
              </form>
            )}
          </div>

          {/* INFO PANEL */}
          <div className="contact-info-col" ref={infoRef}>
            <div className="reveal from-right">
           
              <h2 className="contact-info-col__heading">Reach<br/><span>Our Team</span></h2>
              <div className="red-line"/>
            </div>

            {/* ── 3 Partners ── */}
            <div className="contact-partners reveal delay-2">
              {PARTNERS.map((p, i) => (
                <div key={i} className="contact-partner-card" style={{'--pc': p.color}}>
                  <div className="contact-partner-card__avatar" style={{background: p.color}}>
                    {p.initial}
                  </div>
                  <div className="contact-partner-card__info">
                    <strong className="contact-partner-card__name">{p.name}</strong>
                    <span className="contact-partner-card__role">{p.role}</span>
                    {p.phones.map((ph, j) => (
                      <a key={j} href={`tel:${ph.replace(/\s/g,'')}`} className="contact-partner-card__phone">
                        📞 {ph}
                      </a>
                    ))}
                    {p.emails.map((em, j) => (
                      <a key={j} href={`mailto:${em}`} className="contact-partner-card__email">
                        ✉ {em}
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Unit Addresses */}
            <div className="contact-units reveal delay-3">
              {UNITS.map((u, i) => (
                <div key={i} className="contact-unit-row">
                  <span className={`contact-unit-badge contact-unit-badge${u.badge}`}>{u.label}</span>
                  <a
                    href={u.mapLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-unit-addr"
                  >
                    {u.address}
                    <span className="cinfo-map-pill"><img src={locationIcon} alt="" className="cinfo-loc-icon" /> Open Map</span>
                  </a>
                </div>
              ))}
            </div>

            {/* WhatsApp block */}
            <div className="contact-wa reveal delay-4">
              <div className="contact-wa__icon">{WA_ICON}</div>
              <div className="contact-wa__text">
                <strong>Prefer WhatsApp?</strong>
                <p>Get instant replies from our engineering team</p>
              </div>
              <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noopener noreferrer" className="contact-wa__btn">
                Open Chat →
              </a>
            </div>

            {/* Quick info */}
            <div className="contact-quick reveal delay-5">
              <div className="contact-quick__item">
                <span className="contact-quick__label">Response Time</span>
                <span className="contact-quick__val">Within 24 Hours</span>
              </div>
              <div className="contact-quick__divider"/>
              <div className="contact-quick__item">
                <span className="contact-quick__label">Working Hours</span>
                <span className="contact-quick__val">Mon – Sat, 9am – 6pm</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── UNIT CAPABILITIES ── */}
      <section className="unit-specs-section section" ref={mapRef}>
        <div className="container">
       
          <h2 className="section-title" style={{textAlign:'center',marginBottom:'2.5rem'}}>Unit Specifications</h2>
          <div className="unit-specs-grid">
            {/* Unit I */}
            <div className="unit-spec-card unit-spec-card--1">
              <div className="unit-spec-card__header">
                <span className="unit-spec-card__badge">Unit I</span>
                <h3 className="unit-spec-card__title">VMC & CNC Machining</h3>
                <p className="unit-spec-card__sub">SIDCO Industrial Estate, Thirumudivakkam</p>
              </div>
              <ul className="unit-spec-card__list">
                {UNIT_I_SPECS.map((s, i) => (
                  <li key={i} className="unit-spec-card__item">
                    <span className="unit-spec-card__dot"/>
                    {s}
                  </li>
                ))}
              </ul>
              <a
                href={UNITS[0].mapLink}
                target="_blank" rel="noopener noreferrer"
                className="unit-spec-card__map-btn"
              >
                <img src={locationIcon} alt="" className="unit-loc-icon" /> View on Map
              </a>
            </div>

            {/* Unit II */}
            <div className="unit-spec-card unit-spec-card--2">
              <div className="unit-spec-card__header">
                <span className="unit-spec-card__badge unit-spec-card__badge--2">Unit II</span>
                <h3 className="unit-spec-card__title">Heavy Duty Machining</h3>
                <p className="unit-spec-card__sub">MKB Industrial Estate, Thirumudivakkam</p>
              </div>
              <ul className="unit-spec-card__list">
                {UNIT_II_SPECS.map((s, i) => (
                  <li key={i} className="unit-spec-card__item">
                    <span className="unit-spec-card__dot unit-spec-card__dot--2"/>
                    {s}
                  </li>
                ))}
              </ul>
              <a
                href={UNITS[1].mapLink}
                target="_blank" rel="noopener noreferrer"
                className="unit-spec-card__map-btn unit-spec-card__map-btn--2"
              >
                <img src={locationIcon} alt="" className="unit-loc-icon" /> View on Map
              </a>
            </div>
          </div>

          {/* Bottom key specs */}
          <div className="unit-bottom-specs">
            {BOTTOM_SPECS.map((s, i) => (
              <div key={i} className="unit-bottom-spec">
                <span className="unit-bottom-spec__icon">⚙</span>
                <span>{s}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── DUAL MAP — correct Google Maps direct links ── */}
      <section className="map-section">
        <div className="container map-header-row">
         
          <h2 className="section-title">Find Us in Thirumudivakkam</h2>
        </div>
        <div className="map-dual-grid">
          {UNITS.map((u, i) => (
            <div key={i} className="map-unit-wrap">
              <div className="map-unit-label">
                <span className={`map-unit-badge ${i === 1 ? 'map-unit-badge--2' : ''}`}>{u.label}</span>
                <span className="map-unit-addr">{u.address}</span>
              </div>
              <div className="map-embed-wrap">
                <iframe
                  className="map-iframe"
                  src={u.embedSrc}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`MILLTECH CNC ${u.label} Location`}
                />
              </div>
              <a
                href={u.mapLink}
                target="_blank" rel="noopener noreferrer"
                className={`map-open-btn ${i === 1 ? 'map-open-btn--2' : ''}`}
              >
                Open in Google Maps →
              </a>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default ContactUs;